import { ref, isRef, type Ref } from 'vue'

export const useFilters = <T>(filters: any[]) => {
  const proxies: Record<string, Ref<any>> = {}
  const normalized = filters.map((filter) => {
    const valueRef = isRef(filter.value) ? filter.value : ref(filter.value ?? filter.defaultValue ?? null)
    proxies[filter.key] = valueRef
    return { ...filter, value: valueRef }
  })

  const apply = (items: T[]) => {
    return items.filter((item) =>
      normalized.every((f) => {
        const v = f.value?.value ?? null
        return f.apply(item, v)
      }),
    )
  }

  return { filters: normalized, proxies, apply }
}
